import React, { useState, useSelector, useEffect } from "react";
import { Formik, Form } from "formik";
import { FormContent } from "./formContent";
import { addStaffModal } from "../../redux/actions/sidebar/sidebarAction";
import { store } from "../../redux/storeConfig/store";
import { createStaff, udateStaff } from "../../redux/actions/api/apiAction";
import { api } from "../../api/api";
import { staffVoiceSchema } from "./voiceAddSchema";
import {
  saveVoiceDraftEdit,
  voiceReviewActionLabel,
} from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";

const StaffForm = ({ name, email, phone, permissions }) => {
  const [permissionsList, setPermissionList] = useState([]);
  const [selectCategories, setSelectedCategories] = useState([])
  let categories = ["Member Relations", "Services And Products", "Reports", "Invoicing and Billing", "Staff And Instructors", "Dashboard View and Setup","Retail"]
  useEffect(() => {
    const getPermissions = async () => {
      let url = `permission?type=STAFF`;
      let res = await api(url, {}, "get");
      if (res.status === 400) {
        setPermissionList([]);
      } else {
        setPermissionList(res.data.data);
      }
    };
    getPermissions()
  }, []);


  const handleSubmit = async values => {
    if (saveVoiceDraftEdit(values)) return;
    if (store.getState().sidebar.staffEdit) {
      let id = store.getState().sidebar.staffFields.id;
      values.permissions = values.permissions.map((item) => `${item}`)
      await store.dispatch(udateStaff(id, values));
    } else {
      values.permissions = values.permissions.map((item) => `${item}`)
      console.log({ pe: values.permissions ,values})
      await store.dispatch(createStaff(values));
    }
  };

  const submit = values => {
    handleSubmit(values);
  };

  const formSchema = staffVoiceSchema;

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={withVoicePrefill("staff", {
          name,
          email,
          phone,
          permissions,
          title: ""
          // visitCount
        })}
        onSubmit={submit}
        validationSchema={formSchema}
      >
        {({
          errors,
          touched,
          handleChange,
          handleBlur,
          values,
          setFieldValue
        }) => (
          <Form>
            <FormContent
              errors={errors}
              touched={touched}
              values={values}
              setFieldValue={setFieldValue}
              permissionsList={permissionsList}
              categories={categories}
              setSelectedCategories={setSelectedCategories}
              selectCategories={selectCategories}
            />
            <div className="bg-white card-panel ex-space-y pt-0">
              <div className="action-wrapper blk-padding-y">
                <div className="action-inner-block">
                  <div className="action-btn-block">
                    <React.Fragment>
                      <button
                        type="button"
                        className="btn btn-medium btn-transparent"
                        onClick={() => {
                          store.dispatch(addStaffModal(false));
                          // history.push("/gym-panel/memberslist");
                        }}
                      >
                        Cancel
                      </button>
                    </React.Fragment>

                    <button className="btn btn-medium" type="submit">
                      {voiceReviewActionLabel(
                        store.getState().sidebar.staffEdit
                          ? "Save Staff"
                          : "Add Staff"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

StaffForm.defaultProps = {
  name: "",
  email: "",
  phone: "",
  title: "",
  permissions: [],
  handleSubmit: values => {
    //console.log(values, "values here");
  }
};

export default StaffForm;
